exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#nav-buttons > li {\r\n    border-radius: 4px;\r\n    height: 50px;\r\n}\r\n\r\n#alert-unset-core-options {\r\n    text-align: left;\r\n}", ""]);

